import useSWR from 'swr';

import { SEARCH_API_QUERY_PARAMS } from '@/constants/urls';
import apiRequest from '@/services/apiRequest';
import { ISearchRentalsById } from '@/services/types/search/rentals/id';
import { getSearchApi } from '@/utility/getCoreApi';

export const useRental = (rentalId?: string | number) => {
  return useSWR<ISearchRentalsById>(
    rentalId ? `${getSearchApi()}/rentals/${rentalId}${SEARCH_API_QUERY_PARAMS}` : null,
    url => apiRequest<ISearchRentalsById>({ url }, true),
    {
      revalidateOnMount: true,
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );
};
